var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 8C16.1992 6.4087 15.6514 4.88258 14.6762 3.75736C13.701 2.63214 12.3783 2 10.9992 2C9.62009 2 8.29745 2.63214 7.32226 3.75736C6.34707 4.88258 5.79922 6.4087 5.79922 8C5.79922 15 3.19922 17 3.19922 17H18.7992C18.7992 17 16.1992 15 16.1992 8Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 20C12.3463 20.3031 12.1276 20.5547 11.8645 20.7295C11.6013 20.9044 11.303 20.9965 10.9993 20.9965C10.6957 20.9965 10.3973 20.9044 10.1342 20.7295C9.87107 20.5547 9.65237 20.3031 9.5 20",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.e38f19db848c2c88d1eb527eb5476b19.svg";
export { ForwardRef as ReactComponent };